"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by PhpStorm.
 * User: i.sollima
 * Contact: i.sollima@accenture.com
 * Date: 24/10/2020
 * Time: 23:46
 */
require("../scss/main.scss");
var Article;
(function (Article) {
    document.querySelectorAll('.article .article-accordion:not(.is-initialized)')
        .forEach(($accordion) => {
        $accordion.classList.add('.is-initialized');
        const $toggle = $accordion.querySelector('.toggle');
        $toggle.addEventListener('click', () => {
            const $accordion = $toggle.parentElement;
            const $content = $accordion.querySelector('.hidden-content');
            if (!$accordion.classList.contains('is-expanded')) {
                $content.style.height = `${$content.scrollHeight}px`;
            }
            else {
                $content.style.removeProperty('height');
            }
            $accordion.classList.toggle('is-expanded');
        });
    });
})(Article || (Article = {}));
